
import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { useState, useCallback } from "react";
import GalleryFilter from "@/components/gallery/GalleryFilter";
import LightweightGalleryGrid from "@/components/optimized/LightweightGalleryGrid";
import { galleryFilters } from "@/data/galleryData";

const GalleryFiltered = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  const handleFilterChange = useCallback((filterId: string) => {
    if (filterId === activeFilter) return;
    
    setIsFilterLoading(true);
    setActiveFilter(filterId);
    
    // Krótszy timeout dla lepszej responsywności
    setTimeout(() => {
      setIsFilterLoading(false);
    }, 100);
  }, [activeFilter]);

  return (
    <section className="section-spacing bg-black min-h-[350px]">
      <div className="container-spacing">
        <div className="text-center mb-16 transition-opacity duration-300">
          <div className="flex justify-center mb-8">
            <div className="p-4 bg-garage-blue/20 rounded-full">
              <Camera className="h-8 w-8 text-garage-blue" />
            </div>
          </div>
          <h2 className="section-title">Galeria prac</h2>
          <p className="text-white/70 max-w-2xl mx-auto text-lg leading-relaxed">
            Zobacz efekty naszej pracy i przekonaj się o jakości usług detailingowych
          </p>
        </div>

        <div className="transition-opacity duration-300">
          <GalleryFilter
            filters={galleryFilters}
            activeFilter={activeFilter}
            isLoading={isFilterLoading}
            onFilterChange={handleFilterChange}
          />
        </div>
        {/* Render fallback in case GalleryGrid does not display images */}
        <div id="gallery-grid-root" className="no-repaint">
          <LightweightGalleryGrid activeFilter={activeFilter} />
        </div>
      </div>
    </section>
  );
};

export default GalleryFiltered;
